import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

// Vehicle Assignment DTO
export interface VehicleAssignmentDto {
  id: number;
  vehicleId: number;
  employeeId: number;
  startDate: string;
  endDate?: string;
  vehicleName?: string;
  vehicleVIN?: string;
}

// Update Vehicle Assignments DTO
export interface UpdateVehicleAssignmentsDto {
  employeeId: number;
  vehicleIds: number[];
}

// Extend the existing API slice with vehicle assignment endpoints
export const vehicleAssignmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all active vehicle assignments
    getAllVehicleAssignments: builder.query<VehicleAssignmentDto[], void>({
      query: () => "vehicleassignments",
      transformResponse: unwrapApiResponse,
      providesTags: ["VehicleAssignments"],
    }),

    // Get vehicle assignments for a specific driver
    getVehicleAssignmentsByDriverId: builder.query<VehicleAssignmentDto[], number>({
      query: (driverId) => `vehicleassignments/${driverId}`,
      transformResponse: unwrapApiResponse,
      providesTags: (result, error, driverId) => [
        { type: "VehicleAssignments", id: driverId },
        "VehicleAssignments",
      ],
    }),

    // Update vehicle assignments for a driver
    updateVehicleAssignments: builder.mutation<boolean, { driverId: number; vehicleIds: number[] }>({
      query: ({ driverId, vehicleIds }) => ({
        url: `vehicleassignments/${driverId}`,
        method: "PUT",
        body: { vehicleIds },
      }),
      transformResponse: unwrapApiResponse,
      invalidatesTags: (result, error, { driverId }) => [
        { type: "VehicleAssignments", id: driverId },
        "VehicleAssignments",
        "TruckDrivers", // Invalidate truck drivers to refresh any cached data
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetAllVehicleAssignmentsQuery,
  useGetVehicleAssignmentsByDriverIdQuery,
  useUpdateVehicleAssignmentsMutation,
} = vehicleAssignmentsApi;
